import React from 'react';

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        style={{
          minHeight: '70vh',
          padding: '6rem 1.5rem 4rem',
          background: '#162A1E',
          color: '#E7E9E4',
          textAlign: 'center',
        }}
      >
        <p className="font-serif-editorial text-2xl mb-4">This page didn’t load.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="text-[11px] tracking-[0.28em] uppercase font-bold text-[#A3C66F] hover:text-[#E7E9E4]"
        >
          Reload
        </button>
      </div>
    );
  }
}
